import Smiley from './Smiley.jsx';
import { WhatsAppGlyph, ArrowL } from './Icons.jsx';
import { WA_URL } from '../config.js';
import { trackWhatsApp } from '../analytics.js';

export default function CTABand({
  title,
  body = 'שליחה 3 משפטים בוואטסאפ. נחזור תוך 48 שעות.',
  cta = 'וואטסאפ עכשיו',
  source = 'cta-band',
}) {
  const heading = title || (
    <>יש לך פרויקט <span className="hl-block tilt-r">שתקוע</span>?</>
  );
  return (
    <section className="cta-band">
      <div className="cta-smy"><Smiley size={200} /></div>
      <div className="cta-smy cta-smy-2"><Smiley size={200} /></div>
      <div className="wrap" style={{ position: 'relative', zIndex: 2 }}>
        <h2>{heading}</h2>
        <p>{body}</p>
        <a
          className="btn btn-dark"
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsApp(source)}
        >
          <WhatsAppGlyph size={20} />
          {cta}
          <ArrowL />
        </a>
      </div>
    </section>
  );
}
